import React, { useState } from "react";
import { Button, Input, useToast } from "@chakra-ui/react";
import { Dropdown } from "primereact/dropdown";
import { AddMaps } from "../../../../../../../core/Services";
import { Message } from "primereact/message";

export default function AddDataPage({
  uniqueCustomerId,
  selectedMonth,
  selectedCustomer,
  DataTypes,
  updateTableData
}) {
  
  const [selectedDataType, setSelectedDataType] = useState("");
  const [value, setValue] = useState("");
  const [totalFollower, setTotalFollower] = useState("");
  const [phoneSearch, setPhoneSearch] = useState("");
  const [error, setError] = useState(false);
  const toast = useToast();

 

  const handleSave = () => {
    if (
      !selectedCustomer ||
      !selectedMonth ||
      !selectedDataType ||
      !value ||
      !phoneSearch ||
      !totalFollower
    ) {
      setError(true);
      toast({
        title: "Hata",
        description: "Lütfen tüm alanları doldurunuz.",
        status: "error",
        duration: 3000,
        position: "top-right",
        isClosable: true,
      });
      return;
    }

    AddMaps(
      uniqueCustomerId,
      selectedDataType,
      value,
      selectedMonth,
      totalFollower,
      phoneSearch
    )
      .then((response) => {
        if (response.message === "Hata") {
          toast({
            title: "Hata",
            description: "Kullanıcya Ait Bu Ay Verisi Zaten Mevcut",
            status: "error",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
        } else {
          setSelectedDataType("");
          setValue("");
          setTotalFollower("");
          setPhoneSearch("");
          setError(false);

          toast({
            title: "Başarılı",
            description: "Veri başarılı bir şekilde kaydedildi.",
            status: "success",
            duration: 3000,
            position: "top-right",
            isClosable: true,
          });
          updateTableData();
        }
      })
      .catch((error) => {
        console.error("Backend'e gönderme hatası:", error);
        toast({
          title: "Hata",
          description: "Veri gönderilirken bir hata oluştu.",
          status: "error",
          duration: 3000,
          position: "top-right",
          isClosable: true,
        });
      });
  };

  return (
    <div className="w-full">
      <div className="mt-2 font-bold w-full">Veri Adı : </div>
      <div>
        <Dropdown
          style={{
            border: `1px solid ${error && !selectedDataType ? "red" : ""}`,
            borderRadius: "1rem",
          }}
          className="w-full"
          value={selectedDataType}
          options={DataTypes?.map((type) => ({
            label: type.name,
            value: type.value,
          }))}
          onChange={(e) => setSelectedDataType(e.value)}
          placeholder="Veri Adı Seçiniz"
        />
      </div>

      <div className="mt-2 font-bold w-full">Web Sitesi Ziyaret : </div>
      <div>
        <Input
          placeholder="Web Sitesi Ziyaret"
          className="w-full"
          name="value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          borderColor={error && !value ? "red" : ""}
        />
      </div>
      <div className="mt-2 font-bold w-full">Yol Tarifi : </div>
      <div>
        <Input
          placeholder="Yol Tarifi"
          className="w-full"
          value={totalFollower}
          onChange={(e) => setTotalFollower(e.target.value)}
          borderColor={error && !value ? "red" : ""}
        />
      </div>
      <div className="mt-2 font-bold w-full">Telefon Arama : </div>
      <div>
        <Input
          placeholder="Telefon Arama"
          className="w-full"
          value={phoneSearch}
          onChange={(e) => setPhoneSearch(e.target.value)}
          borderColor={error && !value ? "red" : ""}
        />
      </div>
      <div className="mt-5 flex justify-content-end">
        <Button onClick={handleSave}> Kaydet</Button>
      </div>
      <Message
        className="mt-4 w-full"
        severity="info"
        text="Google İşletme Profili > Performans
        Yandex Metr!ca"
      />
    </div>
  );
}
